export const FETCH_PERIODOS_REQUEST = "FETCH_PERIODOS_REQUEST";
export const FETCH_PERIODOS_SUCCESS = "FETCH_PERIODOS_SUCCESS";
export const FETCH_PERIODOS_FAILURE = "FETCH_PERIODOS_FAILURE";
